import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useTaskSubmissionGroupsQuery } from "API";

import useFilterParam from "./useFilterParam";

const TaskSubmissionGroup: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("submissionGroup");

  const { data = [], isSuccess, isError } = useTaskSubmissionGroupsQuery();
  const [selected, setSelected] = useFilterParam("submissionGroup", data, {
    defaultToFirst: false,
    ready: isSuccess || isError,
  });
  const selectedLabel = data.find((o) => o.value === selected)?.label ?? title;
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={selectedLabel}
      onChange={setSelected}
      selected={!!selected}
      disabled={!isSuccess}
      value={selected ?? ""}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default TaskSubmissionGroup;
